import type { GrowthCategory } from '@mc/api'

import { usePageData } from 'pages/categories/CategoryPage/components/PageDataProvider'

import { CategoryButton } from './CategoryButton'

export const CategoryPageCategoryButton = (props: {
  category: GrowthCategory
  order: number
}) => {
  const { category } = usePageData()
  return <CategoryButton {...props} currentCategory={category} />
}
